// extracted by mini-css-extract-plugin
export default {"rating":"UC-z","numberOfStars":"VC-z","count":"WC-z","barGraphSpacing":"XC-z","barGraph":"YC-z"};